var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartnerWpengine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 142",
    style: {
      enableBackground: "new 0 0 200 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0ECAD4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logomark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    className: "st0",
    d: "M84.3,108.6h33.8V82.9l-8.1-8.1H92.4l-8.1,8.1V108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    className: "st0",
    d: "M128.1,39.1l-8.1,8.1v17.6l8.1,8.1h25.7V39.1H128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    className: "st0",
    d: "M118.1,3.3H84.3V29l8.1,8.1H110l8.1-8.1V3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    className: "st0",
    d: "M153.8,108.6V82.9l-8.1-8.1H120v33.8L153.8,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    className: "st0",
    d: "M56.6,3.3l-8.1,8.1v25.7h33.8V3.3H56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    className: "st0",
    d: "M120,3.3V29l8.1,8.1h25.7V3.3H120z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    className: "st0",
    d: "M101.2,60.8c-2.7,0-4.8-2.2-4.8-4.8c0-2.7,2.2-4.8,4.8-4.8c2.7,0,4.8,2.2,4.8,4.8 S103.9,60.8,101.2,60.8L101.2,60.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    className: "st0",
    d: "M82.4,39.1H48.5v33.8h25.7l8.1-8.1L82.4,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    className: "st0",
    d: "M82.4,82.9l-8.1-8.1H48.5v33.8h25.7l8.1-8.1L82.4,82.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "logotext",
    transform: "translate(0.13 126.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    className: "st1",
    d: "M46.7,8.7c-0.1,0-0.3-0.1-0.3-0.2l-2.7-9.9l0,0l-2.8,9.9c0,0.1-0.2,0.2-0.3,0.2h-3.3 c-0.1,0-0.3-0.1-0.3-0.2L32.1-8.7c0-0.1,0-0.2,0.2-0.2h4.2c0.1,0,0.3,0.1,0.3,0.2l0,0l2.3,10.2l0,0l2.7-10.2c0-0.1,0.2-0.2,0.3-0.2 h2.6c0.1,0,0.3,0.1,0.3,0.2L48,1.5l0,0l2.2-10.2c0-0.1,0.1-0.2,0.3-0.2h4.2c0.1,0,0.2,0,0.2,0.1v0.1L50.4,8.4 c0,0.2-0.2,0.3-0.3,0.2H46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    className: "st1",
    d: "M58.5,8.7c-0.1,0-0.2-0.1-0.2-0.2l0,0V-8.7c0-0.1,0.1-0.2,0.2-0.2l0,0h7C69.9-8.9,72-6.6,72-3 c0,3.4-2.3,5.9-6.5,5.9H63c-0.1,0-0.1,0-0.1,0.1l0,0v5.4c0,0.1-0.1,0.2-0.2,0.2l0,0H58.5z M67.6-3c0-1-0.8-1.9-1.9-2 c-0.1,0-0.2,0-0.3,0H63c-0.1,0-0.1,0-0.1,0.1l0,0v3.7c0,0.1,0,0.1,0.1,0.1l0,0h2.4c1,0.1,2-0.6,2.2-1.7C67.6-2.8,67.6-2.9,67.6-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    className: "st1",
    d: "M78.3,4.3c-0.7-3-0.7-5.9,0-8.9c1.1-3.3,4.7-5,7.8-3.9c1.8,0.6,3.2,2,3.9,3.9 c0.3,1.4,0.6,2.7,0.5,4.1c0,0.2-0.1,0.3-0.3,0.3l0,0H79c-0.1,0-0.2,0.1-0.2,0.2c-0.1,1.2,0.1,2.5,0.5,3.7c0.6,2.3,2.7,3.7,5.1,3.6 c1.9,0.2,3.9-0.7,5-2.3c0.1-0.1,0.3-0.2,0.5-0.1l0,0L90,5.4c0.1,0.1,0.2,0.3,0.1,0.5c0,0,0,0,0,0.1c-1.4,1.8-3.5,2.8-5.7,2.8 C81.6,8.9,79,7.1,78.3,4.3 M89.2-0.9c0.1,0,0.2,0,0.2-0.1l0,0c0-1-0.1-1.9-0.3-3c-0.9-2.7-3.7-4.2-6.5-3.4 c-1.6,0.5-2.8,1.7-3.4,3.4C79-3,78.7-2,78.8-1c0,0.1,0,0.2,0.1,0.2l0,0h10.2V-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    className: "st1",
    d: "M106.1,8.3c-0.2,0-0.3-0.1-0.3-0.3l0,0v-9.9c0-3.9-1.6-5.7-4.9-5.7c-2.7-0.1-5,1.9-5.1,4.7 c0,0.1,0,0.3,0,0.5V8c0,0.2-0.1,0.3-0.3,0.3l0,0h-0.3c-0.2,0-0.3-0.1-0.3-0.3l0,0V-7.9c0-0.2,0.1-0.3,0.3-0.3l0,0h0.3 c0.2,0,0.3,0.1,0.3,0.3l0,0v2.4l0,0c0.9-1.9,3-3.2,5.1-3.1c3.7,0,5.8,2.2,5.8,6.4V8c0,0.2-0.1,0.3-0.3,0.3l0,0L106.1,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    className: "st1",
    d: "M111.9,12.5c-0.1-0.1-0.1-0.3,0-0.5l0,0l0.2-0.2c0.1-0.1,0.3-0.1,0.5,0.1l0,0 c1,1.4,2.7,2,4.4,1.9c3.2,0,5.2-1.6,5.2-5.7V5.6l0,0c-0.8,2-3,3.3-5.2,3.1c-2.5,0.1-4.8-1.5-5.4-4c-0.8-3.1-0.8-6.2,0-9.3 c0.7-2.4,3-4.1,5.4-4c2.3-0.2,4.3,1,5.2,3.1l0,0v-2.4c0-0.2,0.1-0.3,0.3-0.3l0,0h0.3c0.2,0,0.3,0.1,0.3,0.3l0,0V8.3 c0,4.5-2.5,6.6-6.2,6.6C115.1,15,113.1,14.1,111.9,12.5 M121.8,4.3c0.6-2.8,0.6-5.8,0-8.6c-0.9-2.5-3.6-4-6.1-3.1 c-1.5,0.5-2.6,1.6-3.1,3.1c-0.7,2.8-0.7,5.9,0,8.7c0.9,2.5,3.6,3.9,6.2,3.1C120.2,7,121.3,5.8,121.8,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    className: "st1",
    d: "M129-13.4c-0.2,0-0.3-0.1-0.3-0.3l0,0v-1.4c0-0.2,0.1-0.3,0.3-0.3l0,0h0.8c0.2,0,0.3,0.1,0.3,0.3 l0,0v1.4c0,0.2-0.1,0.3-0.3,0.3l0,0H129z M129.3,8.3c-0.2,0-0.3-0.1-0.3-0.3l0,0V-7.9c0-0.2,0.1-0.3,0.3-0.3l0,0h0.3 c0.2,0,0.3,0.1,0.3,0.3l0,0V8c0,0.2-0.1,0.3-0.3,0.3l0,0H129.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    className: "st1",
    d: "M146.9,8.3c-0.2,0-0.3-0.1-0.3-0.3l0,0v-9.9c0-3.9-1.6-5.7-4.9-5.7c-2.7-0.1-5,1.9-5.1,4.7 c0,0.1,0,0.3,0,0.5V8c0,0.2-0.1,0.3-0.3,0.3l0,0h-0.3c-0.2,0-0.3-0.1-0.3-0.3l0,0V-7.9c0-0.2,0.1-0.3,0.3-0.3l0,0h0.3 c0.2,0,0.3,0.1,0.3,0.3l0,0v2.4l0,0c0.9-1.9,3-3.2,5.1-3.1c3.7,0,5.8,2.2,5.8,6.4V8c0,0.2-0.1,0.3-0.3,0.3l0,0L146.9,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    className: "st1",
    d: "M152.2,4.3c-0.7-3-0.7-5.9,0-8.9c1.1-3.3,4.7-5,7.8-3.9c1.8,0.6,3.2,2,3.9,3.9 c0.3,1.4,0.6,2.7,0.5,4.1c0,0.2-0.1,0.3-0.3,0.3l0,0h-11.1c-0.1,0-0.2,0.1-0.2,0.2c-0.1,1.2,0.1,2.5,0.5,3.7 c0.6,2.3,2.7,3.7,5.1,3.6c1.9,0.1,3.9-0.8,5-2.4c0.1-0.1,0.2-0.2,0.5-0.1l0,0l0.2,0.2c0.1,0.1,0.2,0.3,0.1,0.5l0,0 c-1.4,1.8-3.5,2.8-5.7,2.8C155.5,8.9,152.9,7.1,152.2,4.3 M163.1-0.9c0.1,0,0.2,0,0.2-0.1l0,0c0-1-0.1-1.9-0.3-3 c-0.9-2.7-3.7-4.2-6.5-3.4c-1.6,0.5-2.8,1.7-3.4,3.4c-0.2,0.9-0.5,1.9-0.3,3c0,0.1,0.1,0.2,0.1,0.2l0,0h10.2V-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    className: "st1",
    d: "M166-6.7c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2C166.9-4.6,166-5.4,166-6.7 C166-6.6,166-6.6,166-6.7z M169.8-6.7c0-0.9-0.8-1.7-1.7-1.7s-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7C169-4.8,169.7-5.6,169.8-6.7 C169.8-6.6,169.8-6.6,169.8-6.7z M167.4-5.5C167.3-5.5,167.3-5.5,167.4-5.5C167.3-5.6,167.3-5.6,167.4-5.5l-0.1-2.2 c0,0,0-0.1,0.1-0.1l0,0h0.8c0.3,0,0.7,0.2,0.7,0.6v0.1c0,0.2-0.1,0.6-0.5,0.6l0.5,0.9c0,0.1,0,0.1-0.1,0.1h-0.2c0,0-0.1,0-0.1-0.1 L168-6.6h-0.5l0,0v0.9C167.5-5.6,167.5-5.5,167.4-5.5L167.4-5.5L167.4-5.5z M168.5-7.1c0-0.2-0.1-0.3-0.3-0.3h-0.6l0,0v0.7l0,0h0.6 C168.4-6.8,168.5-6.9,168.5-7.1L168.5-7.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerWpengine);
export default __webpack_public_path__ + "static/media/partner-wpengine.b7b1a19097a263a9e5b01a01a1db9a4c.svg";
export { ForwardRef as ReactComponent };